import React from "react";
import useFormattedText from "helpers/useFormattedText";

function Pricing({ price, earlyPrice, description, disclaimer, subscription }) {
  let displayPrice = price;
  let showEarlyPrice = false;
  if (typeof price === 'undefined' || price <= 0) {
    return null;
  }
  // Set disclaimer to an empty string if disclaimer is for virtual price
  if (disclaimer === '*Virtual price includes On Demand'){
    disclaimer = '';
  }
  // Show early bird price if it exists.
  // This will be 0 if the early price cutoff has passed.
  if (typeof earlyPrice !== 'undefined' && earlyPrice > 0 ) {
    displayPrice = earlyPrice;
    showEarlyPrice = true;
  }
  const descriptionClasses = `fs-xs fw-semibold ms-2 text-uppercase ${subscription ? 'd-block' : 'd-inline'}`;
  return (
    <>
      <div className='pricing--teaser'>
        <div className='pricing--teaser__price'>
          <span><strong>${new Number(displayPrice).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>{showEarlyPrice ? '*' : ''}</span>
          <span className={descriptionClasses}>member</span>
          { disclaimer &&
            <div className='pricing--teaser__disclaimer' dangerouslySetInnerHTML={useFormattedText(disclaimer)}/>
          }
        </div>
        {subscription &&
          <span className="fs-xs pricing--teaser__included_subscription">{subscription.label}</span>}
      </div>
      {description && <span className="d-block fs-xs">{description}</span>}
    </>
  );
}

export default Pricing;
